/**
 * @file DivertedBadge.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-06
 * @modified 2026-10-06
 * @description The "Diverted" pill on an order or PO whose customer order was
 *              diverted to another customer. Hover names each diversion (from
 *              → to, when, who, why); a click opens them, with the reason
 *              editable (DiversionsModal). Nothing renders for an order never
 *              diverted.
 */

import React, { useState } from 'react';
import DiversionsModal from './DiversionsModal';
import { diversionsOf, diversionsTitle } from '../utils/orderHub';
import './OrderHub.css';

/**
 * @param {Array}    diversions   customer_orders.diversions
 * @param {number}   orderId      The diverted order (for editing a reason).
 * @param {string}   orderNumber
 * @param {function} onChanged    After a reason was changed.
 * @param {string}   variant      'badge' (default) or 'icon' for tight table cells.
 */
function DivertedBadge({ diversions, orderId, orderNumber, onChanged, variant = 'badge' }) {
  const [open, setOpen] = useState(false);
  const list = diversionsOf(diversions);
  if (!list.length) return null;

  const show = (e) => { e.stopPropagation(); setOpen(true); };
  return (
    <>
      <span
        className={`diverted-badge${variant === 'icon' ? ' is-icon' : ''}`}
        title={diversionsTitle(list)}
        role="button"
        tabIndex={0}
        data-read-safe
        onClick={show}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') show(e); }}
      >
        <span className="material-symbols-rounded">alt_route</span>
        {variant !== 'icon' && `Diverted${list.length > 1 ? ` ×${list.length}` : ''}`}
      </span>
      {open && (
        <span onClick={(e) => e.stopPropagation()}>
          <DiversionsModal
            orderId={orderId}
            orderNumber={orderNumber}
            diversions={list}
            onClose={() => setOpen(false)}
            onChanged={onChanged}
          />
        </span>
      )}
    </>
  );
}

export default DivertedBadge;
